// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"TableCheckbox_checkbox__1vkRZ","disabled":"TableCheckbox_disabled__12lK_","checkboxChecked":"TableCheckbox_checkboxChecked__2IVJO"};